var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcNaviAppointment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 15,
    height: 15,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9091 1.86364H9.05909C8.77273 1.07273 8.02273 0.5 7.13636 0.5C6.25 0.5 5.5 1.07273 5.21364 1.86364H2.36364C1.61364 1.86364 1 2.47727 1 3.22727V14.1364C1 14.8864 1.61364 15.5 2.36364 15.5H11.9091C12.6591 15.5 13.2727 14.8864 13.2727 14.1364V3.22727C13.2727 2.47727 12.6591 1.86364 11.9091 1.86364ZM7.13636 1.86364C7.51136 1.86364 7.81818 2.17045 7.81818 2.54545C7.81818 2.92045 7.51136 3.22727 7.13636 3.22727C6.76136 3.22727 6.45455 2.92045 6.45455 2.54545C6.45455 2.17045 6.76136 1.86364 7.13636 1.86364ZM11.9091 14.1364H2.36364V3.22727H3.72727V5.27273H10.5455V3.22727H11.9091V14.1364Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNaviAppointment);
export default __webpack_public_path__ + "static/media/ic-navi-appointment.ad77f794af757458f765f5277ee4d7fd.svg";
export { ForwardRef as ReactComponent };